<template>
  <!-- 审核流程步骤条 -->
  <div class="review-process" v-if="getProcessList.length > 0">
    <el-steps
    direction="vertical"
    >
    <!-- :status="item.status === 1 ? 'success' : 'error'" -->
    <el-step icon="el-icon-remove-outline" v-if="auditPerson">
      <div slot="title" style="padding-bottom: 20px">{{auditPerson}} 待审核</div>
    </el-step>
      <el-step
      v-for="(item, index) in getProcessList"
      :icon="item.status === 1 ? 'el-icon-circle-check' : 'el-icon-circle-close'"
      :key="`apply${index}`">
        <div slot="title">{{item.modifiedTime}} {{item.auditPerson}} {{item.statusValue}}</div>
        <div slot="description" style="color: #000">
          {{item.remark || '-'}}
        </div>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  props: {
    processList: {
      type: Array,
      default: () => {}
    },
    createTime: {
      type: String,
      default: ''
    },
    createUser: {
      type: String,
      default: ''
    },
    auditPerson: {
      type: String,
      default: ''
    }
  },
  computed: {
    getProcessList() {
      if (!this.createTime) return []
      if (!this.processList.length) return []
      let processList = (this.processList || []).map(item => {
        item.statusValue = item.status === 1 ? '通过申请' 
        : item.status === 2 ? '拒绝申请'
        : item.status === 3 ? '转办申请' 
        : item.status === 4 ? '退回上一级'
        : item.status === 10 ? '提交申请'
        : item.status === 20 ? '修改后重新提交申请' : '提交申请'
        return item
      }).reverse()
      console.log(processList, 'processListprocessList');
        // processList.push({
        //   modifiedTime: this.createTime,
        //   auditPerson: this.createUser,
        //   status: 1,
        //   statusValue: '提交申请'
        // })
      return processList
    }
  }
}
</script>

<style lang="scss" scoped>
.review-process {
  border-top: 1px solid rgb(123, 122, 122);
  padding-top: 20px;
}
</style>